const englishTranslation = {
  sideMenu: {
    importerMenuOption: 'importador',
    globalFiltersMenuOption: 'filtros globais',
    searchRefMenuOption: 'pesquisa por referência',
    searchVehicleMenuOption: 'pesquisa por veículo',
    publicationMenuOption: 'publicação',
    bannersMenuOption: 'banners',
    notificationsMenuOption: 'notificações',
    userPerfilsMenuOption: 'perfis do usuário',
  },
  header: {
    title: 'configurador',
    version: 'Versão 2.0',
    userName: 'Fulano Inglês',
  },
  routes: {
    importerPage: '/importer',
    globalFiltersPage: '/globalFilters',
    searchRefPage: '/searchReference',
    searchVehiclePage: '/searchVehicle',
    searchVehiclePageSearchFiltersTab: '/searchVehicle?tab=searchFilters',
    searchVehiclePageColumnsTab: '/searchVehicle?tab=columns',
    publicationPage: '/publicação',
  },
  pages: {
    importerPage: {
      title: 'Importação e configuração',
      description: 'Está na hora de preparar seu catálogo!\nÉ bem simples e iremos guiar você durante o processo para facilitar a configuração e publicação.',
      cancelButton: 'cancel',
      newImportButton: 'new import',
      publishButton: 'publish current configuration',
      uploadProgressBarLabel: 'Status do envio',
      processingProgressBarLabel: 'Status do processamento',
      successMessage: 'File processed.',
      invalidFileFormat: 'O arquivo enviado não é suportado. Envie apenas arquivos com a extensão .mdb',
    },
    globalFiltersPage: {
      title: 'Filtros globais',
      description: 'Aqui ficam as configurações do conteúdo que será disponibilizado no catálogo.',
      showFilters: 'Exibir este filtro no catálogo',
      showFiltersToolTip: 'Exibe estas opções de filtro \n para usuários do catálogo',
      selectMinOne: 'Selecione no minimo uma opção',
      subtitleVehicle: 'Filtros relacionados aos veículos:',
      subtitleProduct: 'Filtros relacionados aos produtos:',
      errorSelectOne: 'Você deve selecionar ao menos uma opção.',
      vehicleLine: 'Linha de veículo',
      selectVehicleLine: 'Selecionar todas as linhas',
      vehicleType: 'Tipo de veículo',
      selectVehicleTypes: 'Selecionar todos os tipos',
      brand: 'Marcas de veículo',
      selectBrand: 'Selecionar todas as marcas',
      companies: 'Marcas de produto',
      selectCompanies: 'Selecionar todas as marcas',
      categories: 'Categorias de produto',
      selectCategories: 'Selecionar todas as categorias',
      productLines: 'Linhas de produto',
      selectProductLines: 'Selecionar todas as linhas',
      market: 'Mercado de comercialização',
      selectMarket: 'Selecionar todos os mercados',
    },
    searchVehiclePage: {
      title: 'Pesquisa por veículo',
      searchFiltersTab: {
        title: 'filtros de pesquisa',
        atLeastOneSelectedFilter: 'Ao menos um filtro deve ser selecionado.',
        successSaveMessage: 'Filtros salvos com sucesso.',
        otherFiltersText: 'Outros filtros disponiveis',
        otherFiltersText2: 'Selecione os campos que você deseja exibir como filtros:',
        badgeCanBeRequired: 'pode ser obrigatório',
      },
      aboutVehicle: 'Sobre o veículo',
      aboutProduct: 'Sobre o produto',
      fields: 'Campos',
      order: 'Ordenação',
      resultsTab: {
        title: 'exibição de resultados',
        successSaveMessage: 'Colunas salvas com sucesso.',
        otherColumnsText: 'Outras colunas disponiveis',
        otherColumnsText2: 'Selecione os campos que você deseja exibir como colunas:',
        atLeastOneSelectedColumn: 'Ao menos uma coluna deve ser selecionada.',
        tooltipMaxAggregators: 'Máximo de 2 agrupadores selecionados.',
        aggregator: 'Agrupador (1 ou 2)',
        badgeCanBeAggregator: 'pode ser agrupador',
        badgeFilter: 'filtro',
      },
    },
    searchReferencePage: {
      title: 'Pesquisa por referência',
      subtitle: 'Campos selecionados para exibir como coluna:',
      successSaveMessage: 'Colunas salvas com sucesso.',
      otherColumnsText: 'Outras colunas disponiveis',
      otherColumnsText2: 'Selecione os campos que você deseja exibir como colunas:',
      aboutVehicle: 'Sobre o veículo',
      aboutProduct: 'Sobre o produto',
      tooltipMaxAggregators: 'Máximo de 2 agrupadores selecionados.',
      atLeastOneSelectedColumn: 'Ao menos uma coluna deve ser selecionada.',
      fields: 'Campos',
      aggregator: 'Agrupador (1 ou 2)',
      order: 'Ordenação',
      badgeCanBeAggregator: 'pode ser agrupador',
    },
    publicationPage: {
      title: 'Publicação',
      description: 'Ao fazer uma publicação, as configurações atuais ficarão disponíveis para os usuários do catálogo.',
      lastImport: 'última importação:',
      lastPublish: 'última publicação',
      noneImport: 'nenhuma importação até o momento',
      nonePublish: 'nenhuma publicação até o momento',
      ctaPublish: 'publicar',
      ctaPublishLoading: 'publicando',
      confirmationModalPrimaryButton: 'publicar',
      confirmationModalSecondaryButton: 'cancelar',
      confirmationModalMessage: 'Ao fazer uma publicação, as configurações atuais ficarão disponíveis para os usuários do catálogo. Deseja continuar?',
      hasModificationText: 'Há alterações não publicadas!',
      doesntHasModificationsText: 'Não há alterações para serem publicadas.',
      successPublishMessage: 'Alterações publicadas com sucesso!',
      errorPublishMessage: 'Houve um erro ao publicar as alterações.',
    },
  },
  components: {
    fileDropZone: {
      defaultMessagePart1: 'Comece arrastando e soltando seu',
      defaultMessageBoldPart: ' banco de dados ',
      defaultMessagePart2: 'aqui',
      defaultMessageLink: 'ou clique para navegar',
    },
    dropdown: {
      placeholder: '',
    },
  },
  common: {
    saveSuccess: ' Salvo com sucesso.',
    save: 'salvar',
    saving: 'salvando',
    remove: 'remover',
    select: 'selecionar',
    upward: 'ascendente',
    downward: 'descendente',
    orderField: 'campo ordem',
  },
  errorMessages: {
    error: 'erro',
    unknowError: 'Erro desconhecido.',
    'aggregators.must.be.first': 'Agrupadores devem ficar antes das outras colunas.',
    'select.at.least.one.item': 'Selecione pelo menos um item.',
    'select.at.least.one.required': 'Selecione pelo menos um item como obrigatório.',
    'required.must.be.before.not.required': 'Campos obrigatórios devem aparecer antes dos opcionais.',
    'invalid.order': 'Ordenação inválida.',
    'select.at.least.one.and.max.two.aggregators': 'Selecione pelo menos 1 e no máximo 2 agrupadores.',
    'select.at.least.three.columns': 'Selecione no minimo 3 colunas.',
  },
};

export default englishTranslation;
